import { render, staticRenderFns } from "./InformacionGeneralXMeses.vue?vue&type=template&id=8f1926d0"
import script from "./InformacionGeneralXMeses.vue?vue&type=script&lang=js"
export * from "./InformacionGeneralXMeses.vue?vue&type=script&lang=js"
import style0 from "./InformacionGeneralXMeses.vue?vue&type=style&index=0&id=8f1926d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports